import { useTranslation } from 'next-i18next';

/**
 * LockedPlanFloatingText - 플랜 잠금 시 Footer 위에 표시되는 Floating 텍스트
 *
 * @description
 * 퀴즈가 잠겨있을 때 MobileCTAFooter 위에 떠있는 형태로 표시되는 안내 메시지입니다.
 * Figma의 디자인에 따라 pill 형태의 배경과 blur 효과를 가집니다.
 *
 * Features:
 * - Dark background with backdrop blur
 * - White text (body/sm/semibold)
 * - Rounded pill shape
 * - Positioned via parent MobileCTAFooter using translate
 *
 * Figma Reference: node-id=28110-60239
 *
 * @example
 * ```tsx
 * <MobileCTAFooter floatingText={<LockedPlanFloatingText isOwner />}>
 *   <MobileOwnerLockedCTAButtons {...props} />
 * </MobileCTAFooter>
 * ```
 */
export const LockedPlanFloatingText = ({
  isOwner
}: {
  isOwner: boolean;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex items-center justify-center rounded-[32px] bg-black/[0.54] px-md py-2xs backdrop-blur-sm" data-component="locked-plan-floating-text" data-sentry-component="LockedPlanFloatingText" data-sentry-source-file="LockedPlanFloatingText.tsx">
      <p className="whitespace-pre-line text-center text-body-sm-semibold text-inverse">
        {t(isOwner ? 'detail.planExpired.ownerMessage' : 'detail.planExpired.viewerMessage')}
      </p>
    </div>;
};